import { Checkbox, CheckboxProps, FormControlLabel } from "@mui/material";
import { Path, FieldValues, useFormContext, Controller, Control } from "react-hook-form";

type FormCheckboxProps<IFormValues extends FieldValues = FieldValues> = Omit<CheckboxProps, 'name' | 'checked'> & {
    name: Path<IFormValues>,
    control?: Control<IFormValues, any>,
    shouldUnregister?: boolean,
    label: string
}

const FormCheckbox = <IFormValues extends FieldValues = FieldValues>({
     name,
     control,
     shouldUnregister,
     label,
     ...props
 }: FormCheckboxProps<any>) => {

    const formContext = useFormContext<IFormValues>();

    return (
        <Controller
            name={name}
            control={control ?? formContext.control}
            shouldUnregister={shouldUnregister}
            render={({ field, fieldState, formState }) =>
                <FormControlLabel
                    label={label}
                    control={
                        <Checkbox
                            {...props}
                            checked={field.value}
                            onChange={(e, checked) => {
                                (!props.readOnly) && field.onChange(checked);
                                (!props.readOnly) && props.onChange?.(e, checked);
                            }}
                            onBlur={(e) => {
                                field.onBlur();
                                props.onBlur?.(e);
                            }}
                            disabled={props.disabled ?? formState.isSubmitting}
                        />
                    }
                />
            }
        />
    );
};

export default FormCheckbox;